class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector("#cart-notification");
    this.showCardButton = document.querySelector(".show__shopping-cart")
    this.header = document.querySelector("sticky-header");
    this.drawerOverlay = this.querySelector(".drawer-cart__overlay");
    this.onBodyClick = this.handleBodyClick.bind(this);
    const _this = this;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.querySelectorAll('button[type="button"], .close__button').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.querySelectorAll('button[type="button"], .show__shopping-cart').forEach(
      (showButton) => {
        showButton.addEventListener('click', this.close.bind(this))
      }
    )

    if (this.drawerOverlay) {
      this.drawerOverlay.addEventListener('click', function() {
        _this.close();
      });
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    document.body.removeEventListener('click', this.onBodyClick);
    
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    let selectorHtml = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector);

    if (selectorHtml) {
      return selectorHtml.innerHTML;
    }
    return null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') || target.classList.contains('removeItem')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);